export default __webpack_public_path__ + "static/mirai-magical-school-winter-festival_06-c28166299773dc8be99feebe175fb174.png";